<template>
    <div class="container"  v-title="'基本资料'">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title title="基本资料" subtitle="更改您的基本资料"></Title>
            <div id="Information" v-if="show">
                <ul v-if="UserType == 1">
                    <li v-pressed @click="setPortrait">
                        <div class="left">头像</div>
                        <div class="right">
                            <img class="profile_picture" :src="personal.HeadImageUrl || personalDefaultImg" :onerror="`this.src='${personalDefaultImg}'`" >
                            <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                        </div>
                    </li>
                    <li v-pressed v-href="'/Account/ChangeNickname/' + personal.Nickname">
                        <div class="left">昵称</div>
                        <div class="right">
                            <span>{{personal.Nickname}}</span>
                            <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                        </div>
                    </li>
                    <li v-pressed v-href="'/Account/MySuperior' + (personal.CompanyName?'/'+personal.CompanyName:'')">
                        <div class="left">工作单位</div>
                        <div class="right">
                            <span class="new" v-if="!personal.CompanyName">未填写</span>
                            <span v-else style="width:3.5rem">{{personal.CompanyName}}</span>
                            <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                        </div>
                    </li>
                </ul>
                <ul v-else>
                    <li v-pressed @click="setPortrait">
                        <div class="left">头像</div>
                        <div class="right">
                            <img class="profile_picture" :src="company.LogoUrl || companyDefaultImg" :onerror="`this.src='${companyDefaultImg}'`" >
                            <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                        </div>
                    </li>
                    <li>
                        <div class="left">机构全称</div>
                        <div class="right"><span style="width:3.5rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{company.FullName}}</span></div>
                    </li>
                    <li>
                        <div class="left">机构简称</div>
                        <div class="right"><span>{{company.Name}}</span></div>
                    </li>
                    <li v-pressed v-href="'/Account/MySuperior' + (company.ParentName?'/'+company.ParentName:'')">
                        <div class="left">上级单位</div>
                        <div class="right">
                            <span class="new" v-if="!company.ParentName">未填写</span>
                            <span v-else style="width:3.5rem">{{company.ParentName}}</span>
                            <YD-image src="icon/icon_table_cell_arrow"></YD-image>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
    GetUserProfile
} from "@/api"
import {
    UserSetAvatar,
    CompanySetLogo
} from "@/api/user"
import {
    updatePortrait
} from "@js/appInteraction"
export default {
    name:"Information",
    data(){
        return {
            show:false,
            personalDefaultImg: require('@images/个人@3x.png'),
            companyDefaultImg: require('@images/机构@3x.png'),
            personal:{},
            company:{},
            UploaderOptions:{}
        }
    },
    created(){
        GetUserProfile().then(data=>{
            if(data.Code == 0){
                this.show = true;
                this.company = data.CompanyInfo;
                this.personal = data.PersonalInfo;
                this.UploaderOptions = data.UploaderOptions;
            }
        })
    },
    computed:{
        ...mapGetters(['UserType'])
    },
    methods:{
        setPortrait(){
            updatePortrait({
                ...this.UploaderOptions,
                Menu:0,
                Resolutions:'160,160'
            }).then(data=>{
                this.savePortrait(data.Url);
            })
        },
        savePortrait(Url){
            if(this.UserType == 1){
                UserSetAvatar({
                    AvatarUrl: Url
                }).then(data=>{
                    if(data.Code == 0){
                        this.$Toast(`头像${this.personal.HeadImageUrl ? '修改' : '设置'}成功`, 'success');
                        this.personal.HeadImageUrl = Url;
                    }
                })
            }else{
                CompanySetLogo({
                    LogoUrl: Url
                }).then(data=>{
                    if(data.Code == 0){
                        this.$Toast(`头像${this.company.LogoUrl ? '修改' : '设置'}成功`, 'success');
                        this.company.LogoUrl = Url;
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    #Information{
        ul{
            height: auto;
            width: 100%;
            padding-top: 32px;
            li{
                height: 112px;
                width: 100%;
                padding: 0 40px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;
                &.pressed{
                    background: #F3F3F3;
                }
                .left{
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                }
                .right{
                    display: flex;
                    align-items: center;
                    justify-content: right;
                    span{
                        @include line-height(44px);
                        font-size: 28px;
                        color: #8B8C8D;
                        font-weight: 400;
                        text-align: right;
                        white-space: nowrap;
                        &.new{
                            display: flex;
                            align-items: center;
                            &::after{
                                content: "";
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                background: #F06E43;
                                border-radius: 50%;
                                margin-left: 16px;
                            }
                        }
                    }
                    img{
                        height: 48px;
                        margin-right: -16px;
                    }
                    .profile_picture{
                        height: 80px;
                        width: 80px;
                        border-radius: 20px;
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>